import React from "react";
import Cart from "../../components/Cart/Cart";

function CartPage() {
  return (
    <div>
      <Cart />
    </div>
  );
}

export default CartPage;
